import React from 'react'
import classNames from 'classnames/bind'
import styles from './AdminFooter.module.scss'

const cx = classNames.bind(styles)

function AdminFooter() {
  const year = new Date().getFullYear()
  return (
    <footer className={cx('footer')}>
      <span className={cx('copy')}>© {year} MemoSlate</span>
      <div className={cx('meta')}>
        <span>admin</span>
      </div>
    </footer>
  )
}

export default AdminFooter
